
<ng-container>

    <div *ngIf="!thesaurus?.hierarchical" class="row">
        <div class="col-4 backLink">
            <a (click)="onBackLinkClick()" id="backLink" role="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" class="bi bi-chevron-double-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                    <path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                </svg>
                <span>{{'backToResults' | i18next}}</span>
            </a>
        </div>
        <div class="col-8"></div>
    </div>

   <div>
        <app-icon-legend [thesaurusId]="thesaurus?.id ?? ''"></app-icon-legend>
    </div>

    <div class="row explode-major-col-wrapper">
        <div *ngIf="isMajor() || isExplode()" class="explode-major-col-label">
            <span *ngIf="isExplode()">Explode</span>
            <span *ngIf="isMajor()">Major</span>
        </div>
    </div>

    <div *ngIf="thesaurus?.hierarchical" class="viewToggle row">
        <div class="col-12 viewToggleButtons">
            <a id="hierarchicalViewButton" (click)="setHierarchicalView()" (keydown.enter)="setHierarchicalView()" [class.active]="!termsService.getIsRelationalView()" role="button" tabindex="-1">
                <label for="hierarchicalViewButton">{{'hierarchicalView' | i18next}}</label>
            </a>
            <span>|</span>
            <a id="relationalViewButton" (click)="setRelationalView()" (keydown.enter)="setRelationalView()" [class.active]="termsService.getIsRelationalView()" role="button" tabindex="0">
               <label for="relationalViewButton">{{'relationalView' | i18next}}</label>
            </a>

        </div>
        <!-- <div class="col-8"></div> -->
    </div>

    <div id="termsWrapper" tabindex="-1">
        <div *ngIf="termsService.getIsRelationalView(); then relationalViewContainer else hierarchicalViewContainer"></div>
    </div>

    <ng-template #relationalViewContainer>
        <div id="termName">
            <div *ngIf="isUseForTerm; then useInsteadName else entryName"></div>
        </div>

        <ng-template #entryName>
            <app-thesaurus-entry #thesEntry *ngIf="entry" [entry]="entry" [notesId]="''" [linkable]="false" [index]="'0'" [explode]="isExplode()" [major]="isMajor()"></app-thesaurus-entry>
            <div id="associatedTerms">
                <div *ngIf="hasBroaderTerms" id="broaderTerms">
                    <h4>{{'broaderTerms' | i18next}}</h4>
                    <div *ngFor="let broaderTerm of entry.broaderTerms; index as i" class="broader-term-wrapper">
                        <app-thesaurus-entry #thesEntry [entry]="broaderTerm" [notesId]="'BT'" [collapsingNotesId]="'BT'" [index]="i.toString()" [explode]="isExplode()" [major]="isMajor()"></app-thesaurus-entry>
                    </div>
                </div>
                <div *ngIf="hasNarrowerTerms" id="narrowerTerms">
                    <h4>{{'narrowerTerms' | i18next}}</h4>
                    <div *ngFor="let narrowerTerm of entry.narrowerTerms; index as i" class="narrower-term-wrapper">
                        <app-thesaurus-entry #thesEntry [entry]="narrowerTerm" [notesId]="'NT'" [collapsingNotesId]="'NT'" [index]="i.toString()" [explode]="isExplode()" [major]="isMajor()"></app-thesaurus-entry>
                   </div>
                </div>
            </div>
        </ng-template>

        <ng-template #useInsteadName>
            <app-thesaurus-entry #thesEntry *ngIf="entry" [entry]="useTermsInstead" [notesId]="''" [linkable]="false" [index]="'0'" [explode]="isExplode()" [major]="isMajor()"></app-thesaurus-entry>
            <div id="useFor" class="small">
                {{'useFor' | i18next}} <span class="strong">{{entry.name}}</span>
            </div>
            <div id="associatedTerms">
                <div *ngIf="hasBroaderTerms" id="broaderTerms">
                    <h4>{{'broaderTerms' | i18next}}</h4>
                    <div *ngFor="let broaderTerm of entry.broaderTerms; index as i" class="broader-term-wrapper">
                        <app-thesaurus-entry #thesEntry [entry]="broaderTerm" [notesId]="'BT'" [collapsingNotesId]="'BT'" [index]="i.toString()" [explode]="isExplode()" [major]="isMajor()"></app-thesaurus-entry>
                    </div>
                </div>
                <div *ngIf="hasNarrowerTerms" id="narrowerTerms">
                    <h4>{{'narrowerTerms' | i18next}}</h4>
                    <div *ngFor="let narrowerTerm of entry.narrowerTerms; index as i" class="narrower-term-wrapper">
                        <app-thesaurus-entry #thesEntry [entry]="narrowerTerm" [notesId]="'NT'" [collapsingNotesId]="'NT'" [index]="i.toString()" [explode]="isExplode()" [major]="isMajor()"></app-thesaurus-entry>
                    </div>
                </div>
            </div>
        </ng-template>

    </ng-template>

    <ng-template #hierarchicalViewContainer>
        <div *ngIf="entry" id="hierarchicalTermView">
            <app-thesaurus-hierarchical-view [entryOrdinal]="entry.termOrdinal" [thesaurus]="thesaurus" [token]="token" [explode]="isExplode()" [major]="isMajor()"></app-thesaurus-hierarchical-view>
        </div>
    </ng-template>
</ng-container>
